import { Dayjs } from "dayjs";
import { z } from "zod";

export const meetingDaySchema = z
  .object({
    meetingDay: z.string().min(1, "Le jour de réunion est requis"),
    startTime: z
      .custom<Dayjs | null>()
      .refine((val) => val !== null, "L'heure de début est requise"),
    endTime: z
      .custom<Dayjs | null>()
      .refine((val) => val !== null, "L'heure de fin est requise"),
    effectiveDate: z
      .custom<Dayjs | null>()
      .refine((val) => val !== null, "La date d'application est requise"),
    notifyByEmail: z.boolean().default(false),
  })
  .refine(
    (data) => {
      if (!data.startTime || !data.endTime) return true;
      return data.endTime.isAfter(data.startTime);
    },
    {
      message: "L'heure de fin doit être postérieure à l'heure de début",
      path: ["endTime"],
    },
  );
